import React from 'react';
import { LoaderButton } from 'components/common/LoadingButton';

interface ModalFooterProps {
  onCancel: () => void;
  primaryText: string;
  primaryType?: 'submit' | 'button';
  onPrimary?: () => void;
  isSaving?: boolean;
  className?: string;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  onCancel,
  primaryText,
  primaryType = 'submit',
  onPrimary,
  isSaving = false,
  className = '',
}) => (
  <div className={`flex items-center justify-end gap-3 border-t border-[#1C1D26] pt-5 ${className}`}>
    <button
      type="button"
      onClick={onCancel}
      disabled={isSaving}
      className="px-5 py-2.5 text-sm font-semibold text-[#8e94a5] hover:text-white transition-all disabled:opacity-50"
    >
      Cancel
    </button>
    <LoaderButton
      type={primaryType}
      onClick={onPrimary}
      className="!m-0 !py-2.5 !px-6 rounded-xl font-bold bg-gradient-to-r from-[#8b5cf6] to-[#6366f1] hover:from-[#7c3aed] hover:to-[#4f46e5] text-white transition-all min-h-[42px] hover:shadow-lg hover:shadow-[#8b5cf6]/20 disabled:opacity-50 disabled:cursor-not-allowed"
      text={primaryText}
      isLoading={isSaving}
    />
  </div>
);
